import socket from '@/plugins/socket'

const person = {
  id: null,
  nickname: ''
}

export default {
  namespaced: true,
  state: {
    list: {},
    callback: null
  },
  mutations: {
    load: (state, dataPerson) => {
      const newPerson = Object.assign({}, person)
      newPerson.id = dataPerson.id
      newPerson.nickname = dataPerson.nicknameFr

      state.list[newPerson.id] = newPerson
    },
    searched: (state, data) => {
      state.list = data.sort((a, b) => {
        let value = a.nameFr.localeCompare(b.nameFr) * 100
        if (value === 0) {
          value = a.firstnameFr.localeCompare(b.firstnameFr)
        }
        return value
      })
      if (state.callback) {
        state.callback(state.list)
        state.callback = null
      }
    }
  },
  actions: {
    init: (state, data) => { socket.get('MainPerson', 'Main/Person/searched') },
    get: (state, data) => {
      if (data.callback) {
        state.state.callback = data.callback
      }
      socket.get('MainPerson', 'Main/Person/searched', data)
    }
  },
  getters: {
    list: (state) => state.list,
    loading: (state) => state.loading,
    nickname: (state, getters) => (personId) => state.list[personId]?.nickname
  }
}
